import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";
import { useMutation, useQuery } from "@apollo/client";
import { AFTER_FOURDAY_NOT_PAYMENT_ORDER, GET_FOUR_DAY_ORDER_PAYMENT, GET_PAYMENT_ORDERS } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import { FiDownload } from "react-icons/fi";
import CustomPagination from "../components/Pagination.js";
import AdminHeader from "./AdminHeader.js";
import { UPDATE_TODAY_PAYMENT_STATUS } from "../graphql/Mutation/Ordre.js";
import Table from "../components/Table/index.jsx";
import { CREATE_UPDATE_SELLER_TRANSACTION } from "../graphql/Query/SellerTransaction.js";
import { toast } from "react-toastify";
import Loader from "../components/Loader.js";


const AdminCodSellerPayment = () => {
    const [activeTab, setActiveTab] = useState("Open Today Payment");
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [cod_payment_status, setcod_payment_status] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [isOn, setIsOn] = useState(false);
    const [createSellerPaymentTransaction, { loading: loadingData }] = useMutation(CREATE_UPDATE_SELLER_TRANSACTION);
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_FOUR_DAY_ORDER_PAYMENT, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            isOpenTodayPayment: activeTab === 'Open Today Payment' ? true : false,
            email: searchUser
            // "orderStatus": null,
            // "codPaymentStatus": cod_payment_status
        },
        fetchPolicy: "cache-and-network"
    })
    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    useEffect(() => {
        if (GetOrderOrder?.getAfterFourDayOfDeliveryOrder?.data) {
            setOrderData(GetOrderOrder?.getAfterFourDayOfDeliveryOrder?.data);
        }
    }, [GetOrderOrder]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        refetch();

    };

    const toggleClose = async (customerId, orderIds, totalPayAmount) => {

        try {
            const response = await createSellerPaymentTransaction({
                variables: { input: { customerId: customerId, orderIds: orderIds, paymentAmount: totalPayAmount.toString(), totalShipment: orderIds?.length, cod_payment_status: "Paid" } },
            });
            // console.log('✌️response --->', response);
            if (response?.data?.createUpdatePayment?.status) {
                toast.success(response?.data?.createUpdatePayment?.message);
                refetch();
            } else {
                toast.error(response?.data?.createUpdatePayment?.message)
            }
        } catch (err) {
            toast.error(err)
            console.error("Error updating payment status:", err);
        }
    };
    const CODTableColumns = [
        {
            name: "No.",
            sortable: true,
            cell: (row, index) => index + 1 + ((page - 1) * limit)
        },

        {
            name: "Email ID",
            sortable: true,
            selector: (row) => row?.email,
            cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500" }}>{row.email}</span>,
            width: "360px",
        },

        {
            name: "Total Pay Amount (Today)",
            sortable: true,
            selector: (row) => (`₹${row?.totalPayAmount}`),
            // width: "160px",
        },
        {
            name: "Shipment Details",
            sortable: true,
            cell: (row) => <Link to="/adminSingleCodPayment" state={{ customerId: row?.customerId, email: row?.email }}>
                View Details
            </Link>,
            width: "150px",
        },
        {
            name: "Close",
            sortable: true,
            cell: (row) => <button onClick={() => toggleClose(row?.customerId, row?.orders, row?.totalPayAmount)}
                className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
            >
                {row?.isOpenTodayPayment ? "Paid" : "-"}
            </button>,
            width: "150px",
        },
    ];
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            AdminSide Payment History
                        </h1>
                        {/* <button
                            // onClick={downloadExcel}
                            className="flex items-center px-4 py-1 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            <FiDownload className="mr-2 text-lg sm:text-xl" />
                            Export
                        </button> */}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value) }}
                            />
                        </div>

                        {/* 
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Order IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Order ID"
                            />
                        </div>
                      
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div> */}

                        {/* <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={channelOptions}
                                defaultValue={channelOptions[0]}
                                className="w-full"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            fontSize: '0.875rem',
                                            color: '#000000',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',

                                    }),
                                }}
                            />
                        </div> */}


                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}





                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "Open Today Payment",
                            "Close Today Payment",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Shipment Table Section */}
                <h1 className="mt-7 mb-2 font-bold text-gray-800">
                    4 Days After Sending - <span className="font-medium">Payment Status</span>
                </h1>

                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={CODTableColumns}
                        data={orderData || []}
                        currentPage={page}
                        totalRecords={GetOrderOrder?.getAfterFourDayOfDeliveryOrder?.count || 0}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={loading}
                        // deleteData={DeleteProduct}
                        handlePagination={handlePagination}
                    // multiSelectRow={onSelectedRowsChange}
                    />
                </div>
            </div >
        </>
    )
}
export default AdminCodSellerPayment
